import { useEffect, useRef, useState } from 'react';
import { HexAlphaColorPicker } from 'react-colorful';

import clsx from 'clsx';

import {
  applyAlphaRules,
  DEFAULT_COLOR,
  POSTION_STYLES,
  TRANSPARENT_PATTERN_STYLES
} from '@/components/generic/ColorPicker/color-picker-config';
import { ClickOutsideWrapper } from '@/components/layouts/ClickOutsideWrapper';
import { POSITION } from '@/enums/BaseEnums';
import { HexColor } from '@/types';

type ColorPickerProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  color: HexColor;
  onChange: (color: HexColor) => void;
  className?: string;
  position?: POSITION;
  isDisabled?: boolean;
  showColorPreview?: boolean;
};

export const ColorPicker = ({
  isOpen,
  setIsOpen,
  color,
  onChange,
  className = '',
  position = POSITION.TOP,
  isDisabled = false,
  showColorPreview = true
}: ColorPickerProps) => {
  const [pickerColor, setPickerColor] = useState(DEFAULT_COLOR);
  const currenColor = useRef(pickerColor);

  useEffect(() => {
    setPickerColor(color);
    currenColor.current = color;
  }, [color]);

  const handleColorChange = (newColor: string) => {
    const finalColor = applyAlphaRules(currenColor.current || '', newColor);
    setPickerColor(finalColor);
    currenColor.current = finalColor;
    onChange(finalColor as HexColor);
  };

  return (
    <div
      onClick={() => !isDisabled && setIsOpen(true)}
      data-prevent-click-outside={true}
      className={clsx('relative', className)}>
      {showColorPreview && (
        <div
          className={clsx(
            'flex size-9 items-center justify-center rounded-md border border-blue-powder bg-white transition-all duration-300',
            isDisabled ? 'pointer-events-none select-none opacity-50' : 'cursor-pointer'
          )}>
          <div style={TRANSPARENT_PATTERN_STYLES} className='absolute size-[30px] rounded-md' />
          <div style={{ backgroundColor: pickerColor }} className='z-10 size-[30px] rounded-md' />
        </div>
      )}
      {isOpen && (
        <ClickOutsideWrapper
          className={clsx('absolute', POSTION_STYLES[position])}
          onClickOutside={() => {
            onChange(currenColor.current as HexColor);
            setIsOpen(false);
          }}>
          <HexAlphaColorPicker
            className=''
            color={pickerColor || DEFAULT_COLOR}
            onChange={handleColorChange}
          />
        </ClickOutsideWrapper>
      )}
    </div>
  );
};
